import { render, staticRenderFns } from "./GoodsPanel.vue?vue&type=template&id=999998d2&scoped=true"
import script from "./GoodsPanel.vue?vue&type=script&lang=js"
export * from "./GoodsPanel.vue?vue&type=script&lang=js"
import style0 from "./GoodsPanel.vue?vue&type=style&index=0&id=999998d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999998d2",
  null
  
)

export default component.exports